<template>
  <section style="position: absolute; top:0; right: 0; z-index: 1000;" @click="debug = !debug">
    <vue-progress-bar/>
    <pre v-show="debug" style="width: 250px">{{ {
        total: service.total,
        progress: progress,
        duration: service.duration,
        completed: service.completed,
        succeeded: service.succeeded,
        failed: service.failed,
      } }}</pre>
  </section>
</template>

<script>
import {debounce} from 'lodash'
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import service from 'services/Progress'

Vue.use(VueProgressBar, {
  color: '#ff3d49',
  thickness: '5px',
  transition: {
    speed: '1s',
    opacity: '0.6s',
    termination: 300
  }
});

export default {

  data () {
    return {
      debug: false,
      started: false,
      service
    }
  },
  computed: {
    progress() {
      return Math.ceil(this.service.progress * 100)
    },
  },

  created () {
    service.$on('start', this.onStart)
    service.$on('progress', this.onProgress)
    service.$on('finish', this.onFinish)
  },

  methods: {
    onStart () {
      this.started = true
      // FIXME a started progress bar seems to finish too early. No idea of the logic inside. Not starting it seems to work better with the (logical) values from the service
      // this.$Progress.start();
    },

    onProgress () {
      if (!this.started) {
        this.onStart()
      }
      this.$Progress.set(this.progress)
    },

    onFinish () {
      this.$Progress.finish();
      this.started = false
    },

  }

}

</script>

<style lang="scss">

</style>